import React, { useEffect, useState } from "react";
import { getAllActive, getById } from "../../../Infrastructure/Services/DataService";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import { inputType } from "../../../Domain/Constants/InputType";
import GenericInsertUpdatePage from "../../../Domain/Components/Functional/GenericInsertPage/GenericInsertPage";
import { toast } from "react-toastify";

function OperatorGameConfigAttachPage(props) {
    const [operators, setOperators] = useState(null);
    const [gameConfig, setGameConfig] = useState(null);
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        const token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        const search = window.location.search;
        const params = new URLSearchParams(search);
        const gameCongId = params.get("entityId");

        getById("game-config/read", gameCongId, token).then((data) => {
            if (data === null) {
                toast.error("Failed to load game config");
            } else {
                setGameConfig(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });

        getAllActive("operator/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load operators");
            } else {
                setOperators(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });
    }, []);

    useEffect(() => {
        if (gameConfig && operators) {
            setColumns([
                {
                    inputType: inputType.SELECT,
                    labelText: "Game",
                    required: true,
                    disabled: true,
                    inputId: "game_config_id",
                    validationFunction: () => {return null;},
                    selectOptions: formatArrayForSelectInput([gameConfig], "name")
                },
                {
                    inputType: inputType.SELECT,
                    labelText: "Operator",
                    required: true,
                    inputId: "operator_id",
                    selectOptions: formatArrayForSelectInput(operators, "company_name"),
                    validationFunction: () => {return null}
                },
                {
                    inputType: inputType.TEXT,
                    labelText: "Internal Game ID",
                    required: true,
                    inputId: "internal_game_id",
                    validationFunction: () => {return null}
                },
                {
                    inputType: inputType.TEXT,
                    labelText: "Provider Game ID",
                    required: true,
                    inputId: "provider_game_id",
                    validationFunction: () => {return null}
                }
            ])
        }
    }, [gameConfig, operators])

    return (
        <GenericInsertUpdatePage inputs={columns}
            setLoggedIn={props.setLoggedIn}
            endpoint={"operator-game-config/create"}
            pageTitle={"Attach Operator Game Config"}
            isUpdate={false} />
    )
}

export default OperatorGameConfigAttachPage;